import {
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Cart } from "../../features/createSecondaryOrder/models";
import { setSecondaryState } from "../../stateManagement/actions/secondaryOrderActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

interface DeliveryDetailsProps {
  editedShippingAddress: string;
  cart: Cart;
  outletId: string | number;
}

export const DeliveryDetails: React.FC<DeliveryDetailsProps> = ({
  editedShippingAddress,
  cart,
  outletId,
}) => {
  const { createNewOrderState } = useSelector(
    (state: any) => state.secondaryOrder
  );
  const dispatch = useDispatch();

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    shippingAddressMandatory,
  } = ConfigDictionary;
  const customShipToAddrStyling =
    (shippingAddressMandatory && !editedShippingAddress) 
      ? { color: "#889096", fontStyle: "italic" }
      : {};

  const updatedShipToAddress =
    editedShippingAddress ||
    (shippingAddressMandatory
      ? "No ship to address available"
      : "");

  return (
    <div className="delivery_details_data">
      {!shippingAddressMandatory && (
        <FormControlLabel
          control={
            <Checkbox
              checked={createNewOrderState?.diffShippingAddress}
              onChange={(e) => {
                dispatch(
                  setSecondaryState(createNewOrderState, {
                    ...createNewOrderState,
                    diffShippingAddress: e.target.checked,
                  })
                );
              }}
              sx={{
                padding: "4px 6px 4px 10px",
                color: "#DFE2E7",
                "&.Mui-checked": {
                  color: "#00bfa5",
                },
                "& .MuiSvgIcon-root": { fontSize: "22px" },
              }}
            />
          }
          componentsProps={{
            typography: { style: { fontSize: "13px" } },
          }}
          label={"Is shipping address different?"}
        />
      )}

      {(createNewOrderState?.diffShippingAddress ||
        shippingAddressMandatory) && (
        <>
          <div className="field-container">
            <Typography sx={{ fontSize: "12px", lineHeight: 2.3 }}>
              Bill to Address:
            </Typography>
            <TextField
              size="small"
              type="text"
              required
              value={cart?.[outletId]?.customer?.shippingAddress || ""}
              InputProps={{
                readOnly: true,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "30px",
                  maxWidth: "85%",
                  "& fieldset": {
                    borderColor: "#EAEAEA",
                  },
                  "&:hover fieldset": {
                    borderColor: "#EAEAEA", // disables hover highlight
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#EAEAEA", // disables focus highlight
                  },
                  "& input": {
                    color: "#202020",
                    fontSize: "13px",
                  },
                },
              }}
            />
          </div>

          <div className="field-container">
            <Typography sx={{ fontSize: "12px", lineHeight: 2.3 }}>
              Ship to Address:
            </Typography>
            <TextField
              size="small"
              type="text"
              required
              value={updatedShipToAddress ?? ""}
              InputProps={{
                readOnly: true,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "30px",
                  maxWidth: "85%",
                  "& fieldset": {
                    borderColor: "#EAEAEA !important",
                  },
                  "&:hover fieldset": {
                    borderColor: "#EAEAEA !important", // disables hover highlight
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#EAEAEA !important", // disables focus highlight
                  },
                  "& input": {
                    color: "#969595",
                    fontSize: "13px",
                  },
                },
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};
